var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { lifecycle } from 'recompose';
import { withRouter } from "react-router-dom";
import { compose, graphql, PageLayout, Spinner, withAnalytics, withGraphqlErrorFlags, withLoadingSpinner, withMountTracking, withServiceNotFoundHandler, withShowFlag, withUser, } from "@atlassiansox/microscopekit";
import Button, { ButtonGroup } from '@atlaskit/button';
import SectionMessage from '@atlaskit/section-message';
import Tooltip from '@atlaskit/tooltip';
import InfoIcon from '@atlaskit/icon/glyph/info';
import SendIcon from '@atlaskit/icon/glyph/send';
import styled from "styled-components";
import serviceQuery from "../../graphql/service-query.query.graphql";
import credoTopicsQuery from "../../graphql/credo-topics-query.query.graphql";
import credoQuery from "../../graphql/credo-query.query.graphql";
import productionReadinessQuery from "../../graphql/production-readiness-query.query.graphql";
import Credo from "./components/credo";
import CredoModal from "./components/credo-modal";
import { ProgressBars } from "./components/progress-bars";
import { CredoProvider } from "../credo-context";
import startCredoWorkflowMutation from "../../graphql/start-credo-workflow.mutation.graphql";
import completeCredoMutation from "../../graphql/complete-credo.mutation.graphql";
import showdown from "showdown";
import ReactHtmlParser from "react-html-parser";
import credoCertificate from "../images/CredoCertification.jpg";
import { LDProvider } from 'launchdarkly-react-client-sdk';
import { FeedbackSurvey } from "./components/feedback-survey";
import createCredoExemptionMutation from "../../graphql/create-credo-exemption.mutation.graphql";
import cancelCredoExemptionMutation from "../../graphql/cancel-credo-exemption.mutation.graphql";
import credoExemptionQuery from "../../graphql/credo-exemption-query.query.graphql";
import { CredoExemptedBadgeComponent, NewCredoExemptionButtonComponent, ViewExemptionButtonComponent } from "./components/exemption/credo-exemption";
import CredoExemptionModal from "./components/exemption/credo-exemption-modal";
import { CredoExemptionProvider, useCredoExemptionState } from "../credo-exemption-context";
showdown.extension('targetlink', function () { return ([{
        type: 'html',
        regex: /(<a [^>]+?)(>.*<\/a>)/g,
        replace: '$1 target="_blank"$2'
    }]); });
showdown.setOption('extensions', ['targetlink']);
var CredoScheduleLink = "http://go.atlassian.com/credo-review";
var LD_PROD_CLIENT_ID = "5f63dfe80a59140b47bd9428";
var LD_STG_CLIENT_ID = "5f68276cf294fc0b5bfc3a55";
var CredosContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n   > * {\n    margin-bottom: 15px;\n    width: 100%;\n    box-sizing: border-box;\n  }\n  > h3 {\n    padding-top: 80px;\n    width: auto;\n  }\n  > h4 {\n    margin-bottom: 40px;\n    width: 100%;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n   > * {\n    margin-bottom: 15px;\n    width: 100%;\n    box-sizing: border-box;\n  }\n  > h3 {\n    padding-top: 80px;\n    width: auto;\n  }\n  > h4 {\n    margin-bottom: 40px;\n    width: 100%;\n  }\n"])));
var CredoBotMessageContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 10px;\n  overflow: hidden;\n  box-shadow: 0 2px 3px 0 rgba(0,0,0,0.2);\n  border: 1px solid #d7d0d0;\n  border-radius: 10px;\n  &:hover {\n      box-shadow: 1px 2px 4px 0 rgba(0,0,0,0.2);\n  }\n"], ["\n  margin-bottom: 10px;\n  overflow: hidden;\n  box-shadow: 0 2px 3px 0 rgba(0,0,0,0.2);\n  border: 1px solid #d7d0d0;\n  border-radius: 10px;\n  &:hover {\n      box-shadow: 1px 2px 4px 0 rgba(0,0,0,0.2);\n  }\n"])));
var getLdClientId = function () {
    // Production ld client id
    if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV.includes('prod')) {
        return LD_PROD_CLIENT_ID;
    }
    // Staging ld client id
    return LD_STG_CLIENT_ID;
};
function isSOC2Compliant(policy) {
    var policyId = policy.id;
    var questions = policy.questions;
    var isSOC2Compliant;
    if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV.includes('prod')) {
        isSOC2Compliant = questions.filter(function (question) { return question.id === policyId + "-4" && question.answer && question.answer.answer === "true"; }).length !== 0;
    }
    else {
        isSOC2Compliant = questions.filter(function (question) { return question.id === policyId + "-55" && question.answer && question.answer.answer === "true"; }).length !== 0;
    }
    return isSOC2Compliant;
}
var isAutomationApplicable = function (data) {
    if ((data.metadata.platform === "micros" || data.metadata.platform === "service-archetype") && data.compliancePolicy && data.compliancePolicy.status === "Active") {
        return true;
    }
    return false;
};
var isAutomationEnabled = function (data, credoReviewAutomationFlagEnabled, credoTier0Automation) {
    if (!credoReviewAutomationFlagEnabled) {
        return false;
    }
    if ((data.compliancePolicy && isSOC2Compliant(data.compliancePolicy)) || data.metadata.sla.serviceTier === 0) {
        return credoTier0Automation;
    }
    return true;
};
var isSelfServeApplicable = function (data, credoReviewAutomationFlagEnabled, credoTier0Automation) {
    if (isAutomationApplicable(data) && isAutomationEnabled(data, credoReviewAutomationFlagEnabled, credoTier0Automation)) {
        return true;
    }
    return false;
};
var isCredoInCompleteStage = function (credoTicket, data, credoReviewAutomationFlagEnabled, credoTier0Automation) {
    return (isSelfServeApplicable(data, credoReviewAutomationFlagEnabled, credoTier0Automation) &&
        (credoTicket.children || []).filter(function (ticket) {
            return !["DONE", "REJECTED", "RISK_ACCEPTED", "NOT_APPLICABLE"].includes(ticket.status.toUpperCase());
        }).length === 0);
};
var CredoView = function (_a) {
    var data = _a.data, credoData = _a.credoData, credoTopicsData = _a.credoTopicsData, productionReadinessData = _a.productionReadinessData, showFlag = _a.showFlag, startCredo = _a.startCredo, completeCredo = _a.completeCredo, credoExemptionData = _a.credoExemptionData, createCredoExemption = _a.createCredoExemption, cancelCredoExemption = _a.cancelCredoExemption, track = _a.track, history = _a.history, user = _a.user;
    // Credo automation flags
    var credoReviewAutomationFlagEnabled = true;
    var credoTier0Automation = true;
    // Automation message banner
    var credoAutomationMessageEnabled = true;
    var credoAutomationMessageContent = 'If you are a non-soc2 tier-3 micros service and want to try the new automation flow, please reach out to us on <a href="https://atlassian.slack.com/archives/CFGC2JNTT">#help-credo</a> and we can allowlist your service. will be served because flag targeting is off.';
    // General help message banner
    var credoDisabled = true;
    var credoBannerEnabled = true;
    var credoBannerMessageContent = 'Credo will sunset by July’24, Please refer <a href="https://hello.atlassian.net/wiki/spaces/CV2/blog/2024/04/10/3606615801/Saying+Farewell+Credo+Linter">this blog</a> for more details.';
    var credoExemptionFlagEnabled = true;
    // const credoExemptionFF: boolean = credoExemptionFlagEnabled || true;
    var credoExemptionFF = credoExemptionFlagEnabled;
    var _b = useState({
        isOpen: false,
    }), modal = _b[0], setModal = _b[1];
    credoData.credo = credoData.error ? undefined : credoData.credo;
    credoExemptionData.credoExemption = credoExemptionData.error ? [] : credoExemptionData.credoExemption;
    var _isCredoInCompleteStage = false;
    var _credoOnGoingTicketDetails = [];
    var _credoOnGoingParentTicketDetails = {
        ticketKey: "NA",
        summary: "NA",
        ticketStatus: "NA",
        tier: -1
    };
    var _servicedne = (credoData.error && credoData.error.message) ? credoData.error.message.includes('404') : false;
    var _complianceComplete = data.service.compliancePolicy && data.service.compliancePolicy.status === "Active" ? true : false;
    var _isSoc2 = data.service.compliancePolicy && isSOC2Compliant(data.service.compliancePolicy);
    var _inProgress = false;
    if (!credoData.loading && credoData.credo) {
        _inProgress = !!credoData.credo.find(function (c) { return ['IN_PROGRESS', 'PENDING'].includes(c.status.toUpperCase()); });
    }
    if (_inProgress && credoData.credo) {
        var credoInProgressParentTicket = credoData.credo.find(function (c) { return ['IN_PROGRESS', 'PENDING'].includes(c.status.toUpperCase()); });
        if (credoInProgressParentTicket) {
            _isCredoInCompleteStage = isCredoInCompleteStage(credoInProgressParentTicket, data.service, credoReviewAutomationFlagEnabled, credoTier0Automation);
            if (_isCredoInCompleteStage) {
                _credoOnGoingParentTicketDetails = {
                    ticketKey: credoInProgressParentTicket.key,
                    summary: credoInProgressParentTicket.summary,
                    ticketStatus: credoInProgressParentTicket.status,
                    tier: credoInProgressParentTicket.tier
                };
                var doneTickets = (credoInProgressParentTicket.children || []).filter(function (ticket) {
                    return ["DONE"].includes(ticket.status.toUpperCase());
                });
                for (var _i = 0, _c = (doneTickets); _i < _c.length; _i++) {
                    var ticket = _c[_i];
                    _credoOnGoingTicketDetails.push({
                        ticketKey: ticket.key,
                        summary: ticket.summary,
                        ticketStatus: ticket.status,
                        tier: ticket.tier
                    });
                }
            }
        }
    }
    var _isCredoCertified = false;
    // Server(credo-web) will map any status to just 3 kinds of statuses. They are: progress, pending and done
    if (!credoData.loading && credoData.credo && credoData.credo.length > 0) {
        _isCredoCertified = credoData.credo.some(function (c) { return ['DONE'].includes(c.status.toUpperCase()) && c.tier <= data.service.metadata.sla.serviceTier; });
    }
    var CredoActions = function (_a) {
        var servicedne = _a.servicedne, inProgress = _a.inProgress, complianceComplete = _a.complianceComplete, isCredoCertified = _a.isCredoCertified, completeCredo = _a.completeCredo;
        var exemptionState = useCredoExemptionState();
        return (React.createElement(ButtonGroup, null,
            isCredoCertified ?
                React.createElement(Tooltip, { content: "CREDO Certified Service" },
                    React.createElement("img", { height: "30px", style: { marginRight: 12, marginTop: 2 }, src: credoCertificate, alt: "CREDO Certified Badge" }))
                : "",
            !isCredoCertified && React.createElement(CredoExemptedBadgeComponent, null),
            exemptionState.metaData.isNewExemptionEnabled && React.createElement(NewCredoExemptionButtonComponent, { isCredoDisabled: credoDisabled }),
            completeCredo ?
                React.createElement(Tooltip, { content: "Click here to complete Credo" },
                    React.createElement(CompleteCredoButton, { servicedne: servicedne }))
                :
                    React.createElement(Tooltip, { content: exemptionState.metaData.isExempted ? inProgress ? "Credo already started" : "Currently this service is exempted from Credo. However, if you wish to start with the Credo review now, please click on New Credo." : exemptionState.metaData.isExemptionPendingApproval ? "You have requested for Credo exemption, please reach out in #help-credo for more details." :
                            inProgress ? "Credo already started" :
                                !complianceComplete ? "Compliance policy not completed" : "Click to start with credo process." },
                        React.createElement(StartCredoButton, { servicedne: servicedne, inProgress: inProgress, complianceComplete: complianceComplete, isExemptionPendingApproval: exemptionState.metaData.isExemptionPendingApproval, isCredoDisabled: credoDisabled })),
            inProgress ?
                React.createElement(Tooltip, { content: "Credo is self serviceable and automated. If automation is not in scope for this service, please schedule a manual review." },
                    React.createElement(Button, { appearance: "link", href: CredoScheduleLink, target: "_blank", isDisabled: credoDisabled }, "Schedule Review"))
                :
                    React.createElement(Tooltip, { content: "Credo is self serviceable and automated. If automation is not in scope for this service, please schedule a manual review." },
                        React.createElement(Button, { appearance: "link", href: CredoScheduleLink, target: "_blank", isDisabled: credoDisabled }, "Schedule Review")),
            React.createElement(ViewExemptionButtonComponent, null)));
    };
    var StartCredoButton = function (_a) {
        var servicedne = _a.servicedne, inProgress = _a.inProgress, complianceComplete = _a.complianceComplete, isExemptionPendingApproval = _a.isExemptionPendingApproval, isCredoDisabled = _a.isCredoDisabled;
        return (React.createElement(Button, { appearance: "primary", onClick: function () {
                setModal({ isOpen: true });
            }, isDisabled: servicedne || inProgress || !complianceComplete || isExemptionPendingApproval || isCredoDisabled }, credoData.credo ? "New Credo" : "Start Credo"));
    };
    var CompleteCredoButton = function (_a) {
        var servicedne = _a.servicedne;
        return (React.createElement(Button, { appearance: "primary", onClick: function () {
                setModal({ isOpen: true });
            }, isDisabled: servicedne }, "Complete Credo"));
    };
    var FeedbackIcon = React.createElement(SendIcon, { label: "Send icon", secondaryColor: "inherit" });
    var BannerWrapper = function (_a) {
        var content = _a.content;
        return (React.createElement("div", { style: { paddingBottom: '2%' } },
            React.createElement("div", { style: { display: 'grid', padding: '2%', border: "1px solid",
                    borderRadius: '5px', gridTemplateColumns: "3% auto" } },
                React.createElement("div", null,
                    React.createElement(InfoIcon, { label: "" })),
                React.createElement("div", null, ReactHtmlParser(content)))));
    };
    var ProdReadinessIndicatorContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 1em;\n  "], ["\n    padding: 1em;\n  "])));
    var ProdReadinessIndicatorCard = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n   box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n   border: 1px solid #d7d0d0;\n   border-radius: 10px;\n   &:hover {\n        box-shadow: 1px 8px 16px 0 rgba(0,0,0,0.2);\n   }\n  "], ["\n   box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n   border: 1px solid #d7d0d0;\n   border-radius: 10px;\n   &:hover {\n        box-shadow: 1px 8px 16px 0 rgba(0,0,0,0.2);\n   }\n  "])));
    var ProdReadinessIndicatorCSS = {
        padding: "4px",
        fontWeight: 500
    };
    var StartCredoMsgCSS = {
        paddingTop: "5px",
        fontSize: 11,
        textAlign: 'center',
        fontWeight: 600
    };
    var prodReadinessSuccessPercent = 0;
    var prodReadinessFailurePercent = 0;
    var prodReadinessNonAutomatedPercent = 0;
    var toolTipData = "";
    if (!productionReadinessData.loading && productionReadinessData.productionReadiness) {
        var credoProdReadinessIndicatorData = productionReadinessData.productionReadiness;
        prodReadinessSuccessPercent = (credoProdReadinessIndicatorData.checks.successChecks / credoProdReadinessIndicatorData.checks.totalChecks) * 100;
        prodReadinessFailurePercent = (credoProdReadinessIndicatorData.checks.failedChecks / credoProdReadinessIndicatorData.checks.totalChecks) * 100;
        prodReadinessNonAutomatedPercent = (credoProdReadinessIndicatorData.checks.nonAutomatedChecks / credoProdReadinessIndicatorData.checks.totalChecks) * 100;
        toolTipData = credoProdReadinessIndicatorData.checks.details;
    }
    var toolTipFooterText = "<br/><br/> <b>Note</b>: The data for the above tickets is filled automatically using Service Linter checks. If there is any discripencies, then re-run the service linter checks from Microscope.<br/>";
    var tootTipStartingText = prodReadinessSuccessPercent === 100 ?
        "Your service is Operational ready! Below are the details about the tickets.<br/><br/>" :
        "Your service is close to being Operational ready! However we see some of these below tickets might need your attention.<br/><br/>";
    var startCredoToolTipMsg = "<br/><br/>Please click on New/Start Credo button to start the CREDO process and action upon the the tickets that need attention.<br/>";
    if (prodReadinessSuccessPercent !== 100) {
        toolTipData = toolTipData + startCredoToolTipMsg;
    }
    toolTipData = tootTipStartingText + toolTipData + toolTipFooterText;
    var prodReadyStartCredoMsg = prodReadinessSuccessPercent === 100 ?
        "You are just a few clicks away from being a CREDO certified service. Please start the CREDO process by clicking New/Start Credo Button."
        : undefined;
    var isProdReadinessIndicatorApplicable = function () {
        return !productionReadinessData.loading
            && productionReadinessData.productionReadiness
            && productionReadinessData.productionReadiness.applicable;
    };
    var showProductionReadinessIndicator = function () {
        try {
            return isProdReadinessIndicatorApplicable()
                && (!credoData.loading && credoData.credo && credoData.credo.length === 0);
        }
        catch (err) {
            return false;
        }
    };
    var ProdReadinessTooltipContent = function () { return React.createElement("div", null,
        " ",
        ReactHtmlParser(toolTipData),
        " "); };
    var credoAutomationLaunchMessaging = credoAutomationMessageEnabled && isAutomationApplicable(data.service) && !isAutomationEnabled(data.service, credoReviewAutomationFlagEnabled, credoTier0Automation) ?
        React.createElement(CredoBotMessageContainer, null,
            React.createElement(SectionMessage, null,
                React.createElement("p", null, ReactHtmlParser(credoAutomationMessageContent))))
        : undefined;
    var credoBannerMessaging = credoBannerEnabled ? React.createElement(BannerWrapper, { content: credoBannerMessageContent }) : undefined;
    return !credoData.loading ? (React.createElement(CredoExemptionProvider, { credoExemptionFF: credoExemptionFF, credo: credoData.credo, complianceComplete: _complianceComplete, soc2: _isSoc2 || false, service: data.service, servicedne: _servicedne, credoExemptionData: credoExemptionData.credoExemption },
        React.createElement(PageLayout, { title: "Credo", actions: React.createElement(CredoActions, { servicedne: _servicedne, inProgress: _inProgress, complianceComplete: _complianceComplete, completeCredo: _isCredoInCompleteStage, isCredoCertified: _isCredoCertified }) },
            credoAutomationLaunchMessaging,
            credoBannerMessaging,
            showProductionReadinessIndicator() ?
                React.createElement(Tooltip, { content: React.createElement(ProdReadinessTooltipContent, null) },
                    React.createElement(ProdReadinessIndicatorCard, null,
                        React.createElement(ProdReadinessIndicatorContainer, null,
                            React.createElement("div", { style: ProdReadinessIndicatorCSS }, "Production Readiness:"),
                            React.createElement(ProgressBars, { bars: [
                                    { now: prodReadinessSuccessPercent, label: prodReadinessSuccessPercent + "%", legendLabel: '% of passing checks', variant: "success" },
                                    { now: prodReadinessNonAutomatedPercent, label: prodReadinessNonAutomatedPercent + "%", legendLabel: '% of non automated checks', variant: "warning" },
                                    { now: prodReadinessFailurePercent, label: prodReadinessFailurePercent + "%", legendLabel: '% of failing checks', variant: "danger" }
                                ] }),
                            prodReadyStartCredoMsg ?
                                React.createElement("div", { style: StartCredoMsgCSS }, prodReadyStartCredoMsg)
                                : undefined))) : undefined,
            (_inProgress && isSelfServeApplicable(data.service, credoReviewAutomationFlagEnabled, credoTier0Automation)) ?
                React.createElement(CredoBotMessageContainer, null,
                    React.createElement(SectionMessage, null,
                        React.createElement("p", { style: { color: "black" } },
                            "Please transition the applicable ticket(s) in ",
                            React.createElement("b", null, "PENDING"),
                            "/",
                            React.createElement("b", null, "IN-PROGRESS"),
                            " status to ",
                            React.createElement("b", null, "IN-REVIEW"),
                            " for the auto-review to kick-in.",
                            React.createElement("br", null),
                            React.createElement("div", { style: { marginTop: "5px", fontSize: "11px" } },
                                React.createElement("b", null, "Note:"),
                                " Our automation run every 10 minutes. Don\u2019t worry if you don\u2019t see the ticket status immediately changed, it will be updated in the upcoming run!")))) : undefined,
            React.createElement(CredosContainer, null, credoData.credo && credoData.credo.length ?
                [
                    credoData.credo.map(function (credo) { return (React.createElement(Credo, { key: credo.key, credo: credo, isOpen: credoData.credo && credoData.credo.length === 1 ? true : undefined })); })
                ]
                : _servicedne ?
                    React.createElement("h3", null, "New service is still initializing. Please come back later to start Credo.") :
                    React.createElement("h3", null, "Credo has not been started for this service")),
            credoTopicsData.credoTopics &&
                React.createElement(CredoProvider, { tier: data.service.metadata.sla.serviceTier, serviceId: data.service.id, soc2: _isSoc2 || false, staticCredoTopics: credoTopicsData.credoTopics || [], credoCompleteStage: _isCredoInCompleteStage, credoOnGoingTicketDetails: _credoOnGoingTicketDetails, credoOnGoingParentTicketDetails: _credoOnGoingParentTicketDetails },
                    React.createElement(CredoModal, { isOpen: modal.isOpen, onClose: function () { return setModal({ isOpen: false }); }, startCredo: startCredo, completeCredo: completeCredo, track: track, showFlag: showFlag, history: history })),
            React.createElement(CredoExemptionModal, { createCredoExemption: createCredoExemption, cancelCredoExemption: cancelCredoExemption, history: history, track: track, user: user, showFlag: showFlag }),
            React.createElement(FeedbackSurvey, { serviceId: data.service.id })))) : React.createElement(Spinner, null);
};
export var withLDProviderCredo = function (Component) { return function (props) {
    return (React.createElement(LDProvider, { clientSideID: getLdClientId(), user: { key: props.id } },
        React.createElement(Component, __assign({}, props))));
}; };
// Use the `compose` function to wrap decorators around your component. These will run before your component code does.
export var CredoPage = compose(withLDProviderCredo, graphql(startCredoWorkflowMutation, { name: "startCredo" }), graphql(completeCredoMutation, { name: "completeCredo" }), graphql(serviceQuery, {}), graphql(credoTopicsQuery, {
    name: "credoTopicsData",
    options: function (props) { return ({
        query: credoTopicsQuery,
        variables: { serviceName: props.id }
    }); }
}), graphql(productionReadinessQuery, {
    name: "productionReadinessData",
    options: function (props) { return ({
        query: productionReadinessQuery,
        variables: { id: props.id }
    }); }
}), graphql(credoQuery, {
    name: "credoData",
    options: function (props) { return ({
        query: credoQuery,
        variables: { id: props.id },
        pollInterval: 60000
    }); }
}), graphql(createCredoExemptionMutation, { name: "createCredoExemption" }), graphql(cancelCredoExemptionMutation, { name: "cancelCredoExemption" }), graphql(credoExemptionQuery, {
    name: "credoExemptionData",
    options: function (props) { return ({
        query: credoExemptionQuery,
        variables: { id: props.id },
        pollInterval: 60000
    }); }
}), withUser, withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, withServiceNotFoundHandler, withAnalytics, withRouter, withMountTracking('Credo.CredoPage'), lifecycle({
    componentDidMount: function () {
        if (!this.props.credoData.loading) {
            this.props.credoData.refetch();
        }
    }
}))(CredoView);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
